import React, { useState, useEffect } from "react";
import Table from "../../../core/common/dataTable/index";
import { contracts } from "../../../core/data/json/contract";
import { Link, useSearchParams } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
  initialSettings,
  status1,
} from "../../../core/common/selectoption/selectoption";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { ptBR } from 'date-fns/locale/pt-BR';
import Select from "react-select";
import DefaultEditor from "react-simple-wysiwyg";
import { all_routes } from "../../router/all_routes";
import ContratosCards from "./contratosCards";
import AddContratoForm from './AddContratoForm'
import { apiService } from '../../../services/api';
import { Contrato, UpdateContratoData, ReverterRenovacaoParams } from '../../../types/contratos';
import ScrollableTable from './components/ScrollableTable';
import { toast } from "react-toastify";
import { Modal } from 'bootstrap';
import { ProtectedComponent } from '../../../components/ProtectedComponent';
import { usePermissions } from '../../../hooks/usePermissions';
import { ProtectedValue } from '../../../components/ProtectedValue';
import RenovacaoContratoModal from './RenovacaoContratoModal';
import { isContratoVencido, isContratoAVencer } from './contratoStatusUtils';

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

const MONTHS_SHORT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
];

const customPtBR = {
  ...ptBR,
  localize: {
    ...ptBR.localize,
    month: (n: number) => MONTHS[n],
    monthShort: (n: number) => MONTHS_SHORT[n]
  }
};

// Registrar o locale personalizado
registerLocale('pt-BR', customPtBR as any);

const Contractslist = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const podeVerValores = hasPermission('CONTRATOS', 'VER_VALORES');
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [contratos, setContratos] = useState<Contrato[]>([]);
  const [filteredContratos, setFilteredContratos] = useState<Contrato[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [contratoSelecionado, setContratoSelecionado] = useState<Contrato | null>(null);
  const [formData, setFormData] = useState<UpdateContratoData>({});
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [searchText, setSearchText] = useState('');
  const [cardsUpdateTrigger, setCardsUpdateTrigger] = useState<number>(0);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [filtroAtivo, setFiltroAtivo] = useState<string | null>(null);
  // Período que acompanha os filtros vindos de cards do dashboard ("novos"/"renovacoes").
  // Separado de dataInicio/dataFim (que filtram por data_inicio) porque estes casos
  // filtram por data_criacao.
  const [cardPeriodo, setCardPeriodo] = useState<{ inicio: string; fim: string } | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showRenovacaoModal, setShowRenovacaoModal] = useState<boolean>(false);
  const [renovacaoContratoId, setRenovacaoContratoId] = useState<number | null>(null);
  const [reverterRenovacaoId, setReverterRenovacaoId] = useState<Contrato | null>(null);
  const [isRevertendo, setIsRevertendo] = useState<boolean>(false);

  // Estados para filtro de período (inicialmente null para mostrar todos)
  const [dataInicio, setDataInicio] = useState<Date | null>(null);
  const [dataFim, setDataFim] = useState<Date | null>(null);


  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const activityToggle = useSelector(
    (state: any) => state?.activityTogglePopup
  );

  const activityToggleTwo = useSelector(
    (state: any) => state?.activityTogglePopupTwo
  );

  // Função para limpar texto de pesquisa
  const handleClearSearch = () => {
    setSearchText('');
  };

  // Função para aplicar filtro baseado no card clicado (cards desta própria página)
  const handleCardFilter = (tipoFiltro: string) => {
    setFiltroAtivo(tipoFiltro);
    setSearchText(''); // Limpar busca quando aplicar filtro de card
    setCardPeriodo(null); // filtros locais não têm período
    if (searchParams.get('filtro')) {
      setSearchParams({}, { replace: true });
    }
  };

  // Função para limpar filtro de card
  const handleClearCardFilter = () => {
    setFiltroAtivo(null);
    setCardPeriodo(null);
    // Remove filtro/inicio/fim da URL sem recarregar a página
    setSearchParams({}, { replace: true });
  };

  // Verifica se uma data (string ISO / "YYYY-MM-DD ...") cai dentro do período do card.
  // Sem período definido => não restringe.
  const dentroDoPeriodoCard = (dataStr?: string | null) => {
    if (!cardPeriodo) return true;
    if (!dataStr) return false;
    const dia = dataStr.slice(0, 10);
    return dia >= cardPeriodo.inicio && dia <= cardPeriodo.fim;
  };

  // isContratoVencido / isContratoAVencer vêm de ./contratoStatusUtils
  // (comparação por data pura, sem fuso) para bater com o card do dashboard:
  // contrato que vence hoje ainda conta como "a vencer".

  // Função para filtrar contratos baseado no card selecionado
  const filtrarContratosPorCard = (contratos: Contrato[], filtro: string) => {
    switch (filtro) {
      case 'a-faturar':
        return contratos.filter(contrato => 
          !isContratoVencido(contrato) && 
          !isContratoAVencer(contrato) &&
          (contrato.valor_total - contrato.valor_recebido) > 0
        );
      
      case 'recebidos':
        return contratos.filter(contrato => contrato.valor_recebido > 0);
      
      case 'a-vencer':
        return contratos.filter(isContratoAVencer);
      
      case 'vencidos':
        return contratos.filter(isContratoVencido);

      case 'novos':
        // Card "Novos" do dashboard: contratos criados no período que NÃO são renovações
        return contratos.filter(contrato =>
          contrato.tipo_contrato !== 'renovacao' &&
          dentroDoPeriodoCard(contrato.data_criacao)
        );

      case 'renovacoes':
        // Card "Renovações" do dashboard: contratos de renovação criados no período
        return contratos.filter(contrato =>
          contrato.tipo_contrato === 'renovacao' &&
          dentroDoPeriodoCard(contrato.data_criacao)
        );

      case 'total':
      default:
        return contratos;
    }
  };

  const forceCloseModal = (modalId: string): void => {
    // 1. Limpar o body completamente
    document.body.classList.remove('modal-open');
    
    // Remover atributos específicos do Bootstrap 5
    document.body.removeAttribute('data-bs-overflow');
    document.body.removeAttribute('data-bs-padding-right');
    
    // Remover estilos inline
    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overflow');
    
    // 2. Remover todos os backdrops
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while(backdrops.length > 0) {
      backdrops[0].parentNode?.removeChild(backdrops[0]);
    }
    
    // 3. Esconder e limpar o modal
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.removeAttribute('aria-modal');
      modalElement.removeAttribute('role');
      modalElement.classList.remove('show');
    }
  };

  // Buscar contratos da API
  const fetchContratos = async () => {
    try {
      setIsLoading(true);
      const response = await apiService.getContratos();

      if (response.success && response.data) {
        console.log('DEBUG - Dados dos contratos recebidos:', response.data);
        // Adicionar a propriedade key em cada contrato para resolver o warning
        const contratosComKey = response.data.map((contrato: Contrato) => ({
          ...contrato,
          key: contrato.id.toString()
        }));

        setContratos(contratosComKey);
        setFilteredContratos(contratosComKey);

        // Incrementar o trigger para atualizar os cards
        setCardsUpdateTrigger(prev => prev + 1);
      } else {
        setError('Não foi possível obter os dados dos contratos');
      }
    } catch (err) {
      console.error('Erro ao buscar contratos:', err);
      setError('Erro ao carregar dados dos contratos');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContratos();
  }, []);

  // Lê filtro/período vindos de um card do dashboard (ex.: /crm/contratos-lista?filtro=novos&inicio=...&fim=...)
  useEffect(() => {
    const filtro = searchParams.get('filtro');
    if (!filtro) return;

    setFiltroAtivo(filtro);
    setSearchText('');

    const inicio = searchParams.get('inicio');
    const fim = searchParams.get('fim');
    if (inicio && fim) {
      setCardPeriodo({ inicio, fim });
    } else {
      setCardPeriodo(null);
    }
    // Executa apenas na montagem / quando a query string muda
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Efeito para inicializar a lista filtrada
  useEffect(() => {
    setFilteredContratos(contratos);
  }, [contratos]);

  // Função para filtrar contratos quando o texto de busca ou filtro de card muda (com debounce)
  useEffect(() => {
    setIsSearching(true);
    const debounceTimeout = setTimeout(() => {
      let filtered = contratos;

      // Primeiro, aplicar filtro de data SOMENTE se AMBAS as datas estiverem selecionadas
      if (dataInicio && dataFim) {
        filtered = filtered.filter(contrato => {
          if (!contrato.data_inicio) return false; // Não mostrar contratos sem data quando filtro ativo

          const dataContrato = new Date(contrato.data_inicio);
          const inicio = new Date(dataInicio);
          const fim = new Date(dataFim);

          dataContrato.setHours(0, 0, 0, 0);
          inicio.setHours(0, 0, 0, 0);
          fim.setHours(0, 0, 0, 0);

          return dataContrato >= inicio && dataContrato <= fim;
        });
      }

      // Em seguida, aplicar filtro de card se houver
      if (filtroAtivo) {
        filtered = filtrarContratosPorCard(filtered, filtroAtivo);
      }

      // Por fim, aplicar filtro de texto se houver
      if (searchText.trim()) {
        const searchTerms = searchText.toLowerCase().trim().split(' ');

        filtered = filtered.filter(contrato => {
          // Campos a serem pesquisados - removendo o campo cliente.nome que não existe
          const searchableFields = [
            contrato.descricao,
            contrato.situacao,
            // Remover referência a cliente.nome que não existe
            formatCurrency(contrato.valor_total)
          ].filter(Boolean).map(field => field?.toLowerCase() || '');

          // Verificar se todos os termos de pesquisa estão presentes em pelo menos um dos campos
          return searchTerms.every(term =>
            searchableFields.some(field => field.includes(term))
          );
        });
      }

      setFilteredContratos(filtered);
      setIsSearching(false);
    }, 300); // 300ms de delay para debounce

    return () => clearTimeout(debounceTimeout);
  }, [searchText, contratos, filtroAtivo, dataInicio, dataFim, cardPeriodo]);

  // Formatar valores monetários
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  // Função para formatar data sem conversão de timezone (parse manual de YYYY-MM-DD)
  const formatDateLocal = (dateString: string): string => {
    if (!dateString) return 'N/A';
    // Parse manual da data no formato YYYY-MM-DD
    const [year, month, day] = dateString.split('-').map(Number);
    // Criar data usando valores locais (UTC evita problema de timezone)
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  // Função para manipular a edição de contrato
  const handleEditContrato = async (id: number) => {
    try {
      setIsLoading(true);
      const response = await apiService.getContratoById(id);

      if (response.success && response.data) {
        setContratoSelecionado(response.data);

        // Inicializa o formulário com os dados do contrato
        setFormData({
          descricao: response.data.descricao,
          data_inicio: response.data.data_inicio,
          data_finalizacao: response.data.data_finalizacao || undefined,
          valor_total: response.data.valor_total,
          situacao: response.data.situacao
        });

        // Converter as strings de data para objetos Date para o DatePicker
        if (response.data.data_inicio) {
          setSelectedDate(new Date(response.data.data_inicio));
        }

        if (response.data.data_finalizacao) {
          setSelectedDate1(new Date(response.data.data_finalizacao));
        }
      } else {
        setError('Não foi possível obter os dados do contrato');
      }
    } catch (err) {
      console.error('Erro ao buscar contrato para edição:', err);
      setError('Erro ao carregar dados do contrato');
    } finally {
      setIsLoading(false);
    }
  };

  // Função para manipular o envio do formulário de edição
  const handleSubmitEdit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!contratoSelecionado) return;

    try {
      setIsLoading(true);

      // Atualizar as datas no formData
      const updatedFormData = {
        ...formData,
        data_inicio: selectedDate ? selectedDate.toISOString().split('T')[0] : undefined,
        data_finalizacao: selectedDate1 ? selectedDate1.toISOString().split('T')[0] : undefined
      };

      const response = await apiService.updateContrato(contratoSelecionado.id, updatedFormData);

      if (response.success) {
        // Fechar o modal/offcanvas de edição
        const closeBtn = document.querySelector('#offcanvas_edit .btn-close') as HTMLElement;
        if (closeBtn) closeBtn.click();

        // Atualizar a lista de contratos
        fetchContratos();

        // Feedback visual (pode ser implementado com toast ou alert)
        toast.success('Contrato atualizado com sucesso!');
      } else {
        setError('Erro ao atualizar contrato: ' + response.message);
      }
    } catch (err: any) {
      console.error('Erro ao atualizar contrato:', err);
      setError('Erro ao atualizar contrato: ' + (err.message || 'Erro desconhecido'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenRenovacao = (contrato: Contrato) => {
    // Verificar se contrato já foi renovado
    if (contrato.id_contrato_renovado) {
      toast.error('Este contrato já foi renovado. Não é possível renovar novamente.');
      return;
    }

    if (contrato.situacao === 'Finalizado com Renovação') {
      toast.error('Este contrato já foi finalizado através de renovação.');
      return;
    }

    setRenovacaoContratoId(contrato.id);
    setShowRenovacaoModal(true);
  };

  // Função para verificar se um contrato é uma renovação
  const isContratoRenovacao = (contrato: Contrato) => {
    return contrato.tipo_contrato === 'renovacao' || contrato.id_contrato_original !== null;
  };

  // Função para abrir modal de reversão de renovação
  const handleReverterRenovacao = (contrato: Contrato) => {
    console.log('🔄 [REVERTER RENOVAÇÃO] Iniciando reversão');
    console.log('🔄 [REVERTER RENOVAÇÃO] Contrato atual (filho):', contrato);

    // Verificar se temos o id_contrato_original
    if (!contrato.id_contrato_original) {
      toast.error('Erro: Contrato não possui vínculo com contrato original.');
      console.error('🔄 [REVERTER RENOVAÇÃO] Contrato não possui id_contrato_original');
      return;
    }

    console.log('🔄 [REVERTER RENOVAÇÃO] ID do contrato original (pai):', contrato.id_contrato_original);
    setReverterRenovacaoId(contrato);
  };

  // Função para confirmar a reversão de renovação
  const confirmReverterRenovacao = async () => {
    if (!reverterRenovacaoId) return;

    try {
      console.log('🔄 [REVERTER RENOVAÇÃO] Confirmando reversão');

      // Validar id_contrato_original
      if (!reverterRenovacaoId.id_contrato_original) {
        toast.error('Erro: Contrato não possui vínculo com contrato original.');
        console.error('🔄 [REVERTER RENOVAÇÃO] id_contrato_original é null/undefined');
        return;
      }

      setIsRevertendo(true);

      const payload: ReverterRenovacaoParams = { id_contrato: reverterRenovacaoId.id_contrato_original };
      console.log('🔄 [REVERTER RENOVAÇÃO] Payload enviado:', payload);
      console.log('🔄 [REVERTER RENOVAÇÃO] Endpoint: /contratos/reverter-renovacao.php');

      const response = await apiService.reverterRenovacao(payload);

      console.log('🔄 [REVERTER RENOVAÇÃO] Resposta da API:', response);

      if (response.success) {
        toast.success('Renovação revertida com sucesso!');

        // Limpar completamente o modal e restaurar o body
        forceCloseModal('reverter_renovacao_modal');

        fetchContratos();
      } else {
        console.error('🔄 [REVERTER RENOVAÇÃO] Erro na resposta:', response.message);
        toast.error('Erro ao reverter renovação: ' + response.message);
      }
    } catch (err: any) {
      console.error('🔄 [REVERTER RENOVAÇÃO] Erro na requisição:', err);
      console.error('🔄 [REVERTER RENOVAÇÃO] Detalhes do erro:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });

      const errorMessage = err.response?.data?.message || err.message || 'Erro desconhecido ao reverter renovação';

      // Exibir mensagem específica para bloqueios
      if (errorMessage.includes('movimentações financeiras') || errorMessage.includes('Empenhos') || errorMessage.includes('Contas a Receber')) {
        toast.error('Não é possível reverter: O novo contrato já possui movimentações financeiras (Empenhos ou Contas a Receber). Exclua-os primeiro.');
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setIsRevertendo(false);
      setReverterRenovacaoId(null);
    }
  };

  // Função para manipular a exclusão de contrato
  const handleDeleteContrato = (id: number) => {
    setDeleteId(id);
  };

  // Função para confirmar a exclusão
  const confirmDeleteContrato = async () => {
    if (!deleteId) return;

    try {
      // Ativar o loading
      setIsDeleting(true);

      const response = await apiService.deleteContrato(deleteId);

      if (response.success) {
        // Limpar completamente o modal e restaurar o body
        forceCloseModal('delete_contracts');

        // Atualizar a lista de contratos
        fetchContratos();

        // Feedback visual
        toast.success("Contrato excluído com sucesso!");
      } else {
        setError('Erro ao excluir contrato: ' + response.message);
      }
    } catch (err: any) {
      console.error('Erro ao excluir contrato:', err);
      setError('Erro ao excluir contrato: ' + (err.message || 'Erro desconhecido'));
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
    }
  };


  // Função para manipular mudanças no formulário
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Definir as colunas da tabela
  const columns = [
    {
      title: "Dt. Início",
      dataIndex: "data_inicio",
      key: "data_inicio",
      sorter: true,
      render: (text: string) => formatDateLocal(text)
    },
    {
      title: "Dt. Fim",
      dataIndex: "data_finalizacao",
      key: "data_finalizacao",
      sorter: true,
      render: (text: string) => formatDateLocal(text)
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
      key: "descricao",
      render: (text: string, record: Contrato) => {
        return (
          <Link
            to={`/crm/contratos/detalhes/${record.id}`}
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px' }}
            title={text || 'Sem descrição'}
          >
            {text || 'Sem descrição'}
          </Link>
        );
      },
    },
    {
      title: "Total",
      dataIndex: "valor_total",
      key: "valor_total",
      sorter: true,
      render: (value: number) => <ProtectedValue module="CONTRATOS" value={formatCurrency(value)} />,
    },
    {
      title: "Total Empenhado",
      dataIndex: "valor_recebido",
      key: "valor_recebido",
      sorter: true,
      render: (value: number, record: any) => (
        <div className="d-flex align-items-center gap-2">
          <ProtectedValue module="CONTRATOS" value={formatCurrency(value)} />
          {podeVerValores && (
            <span className="badge bg-success rounded-pill">
              {record.valor_total > 0 ? ((value / record.valor_total) * 100).toFixed(1) : 0}%
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Saldo do Contrato",
      dataIndex: "saldo_contrato",
      key: "saldo_contrato",
      sorter: true,
      render: (text: string, record: any) => {
        const saldo = (record.valor_total || 0) - (record.valor_recebido || 0);
        return (
          <div className="d-flex align-items-center gap-2">
            <ProtectedValue module="CONTRATOS" value={formatCurrency(saldo)} />
            {podeVerValores && saldo > 0 && (
              <span className="badge bg-warning rounded-pill">
                {record.valor_total > 0 ? ((saldo / record.valor_total) * 100).toFixed(1) : 0}%
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      render: (text: string, record: Contrato) => {
        const hasRenovacoes = (record.numero_renovacoes || 0) > 0;
        const lastRenovacaoDate = record.data_ultima_renovacao 
          ? `Última renovação: ${new Date(record.data_ultima_renovacao).toLocaleDateString('pt-BR')}`
          : '';

        return (
          <div className="d-flex flex-column align-items-start gap-1">
            {text === "Finalizado" && (
              <span className="badge badge-pill badge-status bg-success">
                {text}
              </span>
            )}
            {text === "Em andamento" && (
              <span className="badge badge-pill badge-status bg-secondary">
                {text}
              </span>
            )}
            {text === "Vencido" && (
              <span className="badge badge-pill badge-status bg-danger">
                {text}
              </span>
            )}
            {text === "Aguardando Início" && (
              <span className="badge badge-pill badge-status bg-secondary">
                {text}
              </span>
            )}
            {text === "A Vencer" && (
              <span className="badge badge-pill badge-status bg-warning">
                {text}
              </span>
            )}
            {text === "Finalizado com Renovação" && (
              <span className="badge badge-pill badge-status bg-primary">
                {text}
              </span>
            )}
            {!["Finalizado", "Em andamento", "Vencido", "Aguardando Início", "A Vencer", "Finalizado com Renovação"].includes(text) && (
              <span className="badge badge-pill badge-status bg-info">
                {text}
              </span>
            )}
            
            {hasRenovacoes && (
              <span 
                className="badge badge-soft-info d-inline-flex align-items-center gap-1"
                title={lastRenovacaoDate}
                style={{ fontSize: '10px', padding: '2px 6px', marginTop: '2px' }}
              >
                <i className="ti ti-rotate-clockwise fs-12"></i>
                {record.numero_renovacoes === 1 ? 'Renovado' : `Renovado (${record.numero_renovacoes}x)`}
              </span>
            )}
          </div>
        );
      },
      sorter: true,
    },
    {
      title: "Ações",
      dataIndex: "acoes",
      key: "acoes", // Adicionando key para evitar warnings
      render: (text: string, record: any) => (
        <>
          <ProtectedComponent module="CONTRATOS" action="EDITAR">
            {record.id_contrato_renovado || record.situacao === 'Finalizado com Renovação' ? (
              <span className="dropdown-item text-muted" style={{ cursor: 'not-allowed' }}>
                <i className="ti ti-rotate-clockwise text-muted"></i> Renovado
              </span>
            ) : (
              <Link
                className="dropdown-item"
                to="#"
                onClick={() => handleOpenRenovacao(record)}
              >
                <i className="ti ti-rotate-clockwise text-success"></i> Renovar
              </Link>
            )}
          </ProtectedComponent>


            {isContratoRenovacao(record) && (
              <Link
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#reverter_renovacao_modal"
                onClick={() => handleReverterRenovacao(record)}
              >
                <i className="ti ti-rotate text-warning"></i> Reverter Renovação
              </Link>
            )}


          <ProtectedComponent module="CONTRATOS" action="EDITAR">
            <Link
              className="dropdown-item"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvas_edit"
              to="#"
              onClick={() => handleEditContrato(record.id)}
            >
              <i className="ti ti-edit text-blue"></i> Editar
            </Link>
          </ProtectedComponent>

          <ProtectedComponent module="CONTRATOS" action="EXCLUIR">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_contracts"
              onClick={() => handleDeleteContrato(record.id)}
            >
              <i className="ti ti-trash text-danger"></i> Excluir
            </Link>
          </ProtectedComponent>
        </>
      ),
    },
  ];

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Contratos
                        <span className="count-title">{filteredContratos.length} contratos</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}

                {/* Adicione os cards financeiros aqui */}
                <ContratosCards
                  updateTrigger={cardsUpdateTrigger}
                  onCardClick={handleCardFilter}
                  filtroAtivo={filtroAtivo}
                />

                {/* Filtro de Período */}
                <div className="card mb-4">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <h5 className="card-title mb-0">
                          Filtro de Período
                          {dataInicio && dataFim && (
                            <span className="badge bg-primary ms-2">Ativo</span>
                          )}
                        </h5>
                      </div>
                      <div className="col-md-8">
                        <div className="row align-items-end">
                          <div className="col-md-5">
                            <label className="form-label">Data Início</label>
                            <div className="icon-form">
                              <span className="form-icon">
                                <i className="ti ti-calendar"></i>
                              </span>
                              <DatePicker
                                className="form-control"
                                selected={dataInicio}
                                onChange={(date) => setDataInicio(date)}
                                dateFormat="dd/MM/yyyy"
                                locale="pt-BR"
                                placeholderText="Selecione..."
                                popperClassName="date-picker-higher-z-index"
                                isClearable
                              />
                            </div>
                          </div>
                          <div className="col-md-5">
                            <label className="form-label">Data Fim</label>
                            <div className="icon-form">
                              <span className="form-icon">
                                <i className="ti ti-calendar"></i>
                              </span>
                              <DatePicker
                                className="form-control"
                                selected={dataFim}
                                onChange={(date) => setDataFim(date)}
                                dateFormat="dd/MM/yyyy"
                                locale="pt-BR"
                                placeholderText="Selecione..."
                                popperClassName="date-picker-higher-z-index"
                                isClearable
                              />
                            </div>
                          </div>
                          {(dataInicio || dataFim) && (
                            <div className="col-md-2">
                              <button
                                className="btn btn-outline-danger w-100"
                                onClick={() => {
                                  setDataInicio(null);
                                  setDataFim(null);
                                }}
                                title="Limpar filtro de período"
                              >
                                <i className="ti ti-x"></i> Limpar
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <div className="search-input position-relative">
                          <div className="icon-form mb-3 mb-sm-0">
                            <span className="form-icon">
                              {isSearching ? (
                                <i className="spinner-border spinner-border-sm" role="status" />
                              ) : (
                                <i className="ti ti-search" />
                              )}
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Pesquisar Contratos"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                            {searchText && (
                              <button
                                className="btn btn-sm position-absolute"
                                style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                onClick={handleClearSearch}
                                type="button"
                              >
                                <i className="ti ti-x" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <ProtectedComponent module="CONTRATOS" action="CRIAR">
                            <AddContratoForm />
                          </ProtectedComponent>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>

                  <div className="card-body">
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        {/* Indicador de filtro ativo */}
                        {filtroAtivo && (
                          <div className="alert alert-info d-flex align-items-center py-2 px-3 me-3 mb-0">
                            <i className="ti ti-filter me-2"></i>
                            <span className="me-2">
                              Filtro ativo: <strong>
                                {filtroAtivo === 'a-faturar' && 'SALDO DO CONTRATO'}
                                {filtroAtivo === 'recebidos' && 'EMPENHADO'}
                                {filtroAtivo === 'a-vencer' && 'CONTRATO A VENCER (3 MESES)'}
                                {filtroAtivo === 'vencidos' && 'CONTRATOS VENCIDOS'}
                                {filtroAtivo === 'novos' && 'CONTRATOS NOVOS (NO PERÍODO)'}
                                {filtroAtivo === 'renovacoes' && 'RENOVAÇÕES (NO PERÍODO)'}
                                {filtroAtivo === 'total' && 'TOTAL DE CONTRATOS'}
                              </strong>
                            </span>
                            <button 
                              className="btn btn-sm btn-link p-0 text-decoration-none"
                              onClick={handleClearCardFilter}
                              title="Limpar filtro"
                            >
                              <i className="ti ti-x"></i>
                            </button>
                          </div>
                        )}
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Ordenar{" "}
                          </Link>
                          <div className="dropdown-menu dropdown-menu-start">
                            <ul>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Crescente
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Decrescente
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Visualizados Recentemente
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="#"
                                  className="dropdown-item"
                                >
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Adicionados Recentemente
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /Filter */}

                    {/* Projects List */}
                    {isLoading ? (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Carregando...</span>
                        </div>
                        <p className="mt-2">Carregando contratos...</p>
                      </div>
                    ) : error ? (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    ) : !isSearching && searchText && filteredContratos.length === 0 ? (
                      <div className="text-center py-5">
                        <div className="mb-3">
                          <i className="ti ti-search-off fs-3 text-muted"></i>
                        </div>
                        <h5 className="text-muted">Nenhum contrato encontrado</h5>
                        <p className="text-muted">Sua pesquisa por "{searchText}" não retornou resultados.</p>
                        <button
                          className="btn btn-outline-primary mt-2"
                          onClick={handleClearSearch}
                        >
                          <i className="ti ti-x me-1"></i>
                          Limpar pesquisa
                        </button>
                      </div>
                    ) : (
                      <ScrollableTable dataSource={filteredContratos} columns={columns} />
                    )}
                    {/* /Projects List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}

        {/* CSS para melhorar o z-index do DatePicker */}
        <style>
          {`
            .date-picker-higher-z-index {
              z-index: 9999 !important;
            }
            .react-datepicker-popper {
              z-index: 9999 !important;
            }
            .react-datepicker {
              z-index: 9999 !important;
            }
          `}
        </style>

        <>
          {/* Add New Contracts */}
          <div
            className="offcanvas offcanvas-end offcanvas-large"
            tabIndex={-1}
            id="offcanvas_add"
          >
            <div className="offcanvas-header border-bottom">
              <h4>Adicionar Novo Contrato</h4>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="offcanvas-body">
              <form>
                <div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Assunto <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Data de Início<span className="text-danger">*</span>
                        </label>
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-calendar-check" />
                          </span>
                          <DatePicker
                            className="form-control datetimepicker"
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            locale="pt-BR"
                            placeholderText="dd/mm/aaaa"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Data de Término<span className="text-danger">*</span>
                        </label>
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-calendar-check" />
                          </span>
                          <DatePicker
                            className="form-control datetimepicker"
                            selected={selectedDate1}
                            onChange={handleDateChange1}
                            dateFormat="dd/MM/yyyy"
                            locale="pt-BR"
                            placeholderText="dd/mm/aaaa"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Cliente <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={status1}
                          className="select"
                          placeholder="Escolher"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Tipo de Contrato<span className="text-danger">*</span>
                        </label>
                        <Select
                          options={status1}
                          className="select"
                          placeholder="Escolher"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Valor do Contrato <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Anexo <span className="text-danger">*</span>
                        </label>
                        <div className="drag-attach">
                          <input type="file" />
                          <div className="img-upload">
                            <i className="ti ti-file-broken" />
                            Carregar Arquivo
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="col-form-label">
                          Descrição <span className="text-danger">*</span>
                        </label>
                        <DefaultEditor className="summernote" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    data-bs-dismiss="offcanvas"
                    className="btn btn-light me-2"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#create_success"
                  >
                    Criar
                  </button>
                </div>
              </form>
            </div>
          </div>
          {/* /Add New Contracts */}
          {/* Edit Contracts */}
          <div
            className="offcanvas offcanvas-end offcanvas-large"
            tabIndex={-1}
            id="offcanvas_edit"
          >
            <div className="offcanvas-header border-bottom">
              <h4>Editar Contrato</h4>
              <button
                type="button"
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="offcanvas-body">
              {isLoading ? (
                <div className="text-center p-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmitEdit}>
                  <div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Descrição <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="descricao"
                            value={formData.descricao || ''}
                            onChange={handleFormChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Data de Início<span className="text-danger">*</span>
                          </label>
                          <div className="icon-form">
                            <span className="form-icon">
                              <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={selectedDate}
                              onChange={handleDateChange}
                              dateFormat="dd/MM/yyyy"
                              locale="pt-BR"
                              placeholderText="dd/mm/aaaa"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Data de Término
                          </label>
                          <div className="icon-form">
                            <span className="form-icon">
                              <i className="ti ti-calendar-check" />
                            </span>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={selectedDate1}
                              onChange={handleDateChange1}
                              dateFormat="dd/MM/yyyy"
                              locale="pt-BR"
                              placeholderText="dd/mm/aaaa"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Valor Total <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="valor_total"
                            value={formData.valor_total || 0}
                            onChange={handleFormChange}
                            required
                            min="0"
                            step="0.01"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-3">
                          <label className="col-form-label">
                            Situação <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            name="situacao"
                            value={formData.situacao || ''}
                            onChange={(e) => setFormData({ ...formData, situacao: e.target.value })}
                            required
                          >
                            <option value="">Selecione a situação</option>
                            <option value="Em andamento">Em andamento</option>
                            <option value="Finalizado">Finalizado</option>
                            <option value="Vencido">Vencido</option>
                            <option value="Aguardando Início">Aguardando Início</option>
                            <option value="A Vencer">A Vencer</option>
                            <option value="Finalizado com Renovação">Finalizado com Renovação</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      data-bs-dismiss="offcanvas"
                      className="btn btn-light me-2"
                    >
                      Cancelar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Salvar Alterações
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
          {/* /Edit Contracts */}
          {/* Delete Contracts */}
          <div className="modal fade" id="delete_contracts" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="text-center">
                    <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                      <i className="ti ti-trash-x fs-36 text-danger" />
                    </div>
                    <h4 className="mb-2">Remover Contrato?</h4>
                    <p className="mb-0">
                      Tem certeza de que deseja remover <br /> o contrato selecionado?
                    </p>
                    <div className="d-flex align-items-center justify-content-center mt-4">
                      <Link
                        to="#"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancelar
                      </Link>
                      <button
                        onClick={confirmDeleteContrato}
                        className="btn btn-danger"
                        disabled={isDeleting}
                      >
                        {isDeleting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Excluindo...
                          </>
                        ) : (
                          <>Sim, Excluir</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Delete Contracts */}
          {/* Reverter Renovação */}
          <div className="modal fade" id="reverter_renovacao_modal" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="text-center">
                    <div className="avatar avatar-xl bg-warning-light rounded-circle mb-3">
                      <i className="ti ti-rotate fs-36 text-warning"></i>
                    </div>
                    <h4 className="mb-2">Reverter Renovação?</h4>
                    <p className="mb-0">
                      Esta ação irá cancelar este contrato de renovação e reativar o contrato original. <br />
                      Os valores dos produtos serão restaurados. <br />
                      <strong className="text-danger">Esta ação não pode ser desfeita.</strong>
                    </p>
                    <div className="d-flex align-items-center justify-content-center mt-4">
                      <Link
                        to="#"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                        onClick={() => setReverterRenovacaoId(null)}
                      >
                        Cancelar
                      </Link>
                      <button
                        onClick={confirmReverterRenovacao}
                        className="btn btn-warning"
                        disabled={isRevertendo}
                      >
                        {isRevertendo ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Revertendo...
                          </>
                        ) : (
                          <>Sim, Reverter</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Reverter Renovação */}
          {/* Create Contracts */}
          <div
            className="modal custom-modal fade"
            id="create_success"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0 m-0 justify-content-end">
                  <button
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="success-message text-center">
                    <div className="success-popup-icon bg-light-blue">
                      <i className="ti ti-atom-2" />
                    </div>
                    <h3>Contrato Criado com Sucesso!</h3>
                    <p>Ver os detalhes do contrato criado</p>
                    <div className="col-lg-12 text-center modal-btn">
                      <Link
                        to="#"
                        className="btn btn-light"
                        data-bs-dismiss="modal"
                      >
                        Cancelar
                      </Link>
                      <Link to="#" className="btn btn-primary">
                        Ver Detalhes
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Create Contracts */}

          <RenovacaoContratoModal
            isOpen={showRenovacaoModal}
            onClose={() => setShowRenovacaoModal(false)}
            contractId={renovacaoContratoId}
            onSuccess={() => {
              fetchContratos();
              setShowRenovacaoModal(false);
            }}
          />
        </>
      </>
    </div>
  );
};

export default Contractslist;